import React, { useCallback } from 'react';
import { toast, ToastId } from 'react-toastify';
import { Icon, IconColor, IconName } from 'web-common/src/shared/design-system/components/Icon';

interface ConfirmationToastProps {
  iconName: IconName;
  iconColor?: IconColor;
  label: string;
  actionLabel: string;
  onAction: () => void;
  toastId: ToastId;
}

/**
 * @deprecated The shef-web design system is being retired. web-common has no
 *   counterpart yet — see the migration ticket before adding a new call site.
 * @see https://app.asana.com/0/0/1218340650332756
 */
export const ConfirmationToast: React.FC<ConfirmationToastProps> = ({
  iconName,
  iconColor = IconColor.RASPBERRY,
  label,
  actionLabel,
  onAction,
  toastId,
}) => {
  const handleAction = useCallback(() => {
    onAction();
    toast.dismiss(toastId);
  }, [onAction, toastId]);

  return (
    <div className='flex w-full items-center justify-between gap-3 whitespace-nowrap rounded-md bg-butter-50 px-4 py-3 shadow-md'>
      <div className='flex items-center gap-2'>
        <Icon name={iconName} color={iconColor} size={16} />
        <span className='text-body-400 text-eggplant'>{label}</span>
      </div>
      <button
        type='button'
        onClick={handleAction}
        className='cursor-pointer border-0 bg-transparent p-0 text-body-400 text-eggplant underline'>
        {actionLabel}
      </button>
    </div>
  );
};

interface ShowConfirmationToastArgs {
  /** Stable id — re-calling `show` with the same id replaces the active toast. */
  toastId: string;
  iconName: IconName;
  iconColor?: IconColor;
  label: string;
  actionLabel: string;
  onAction: () => void;
}

/**
 * @deprecated The shef-web design system is being retired. web-common has no
 *   counterpart yet — see the migration ticket before adding a new call site.
 * @see https://app.asana.com/0/0/1218340650332756
 */
export const showConfirmationToast = ({ toastId, ...rest }: ShowConfirmationToastArgs): void => {
  toast(<ConfirmationToast {...rest} toastId={toastId} />, {
    toastId,
    position: toast.POSITION.BOTTOM_CENTER,
    autoClose: 5000,
    hideProgressBar: true,
    closeButton: false,
    className: '!w-fit !min-w-0',
  });
};
